import { createFileRoute } from "@tanstack/react-router";
import KornerAsk from "../components/tk/pages/KornerAsk";

const title = "Korner Ask | Guest memory for ultra-luxury dining rooms | thatKorner";
const description = "Korner Ask puts each guest's allergies, preferences and history in the sommelier's hand, on the order-taking tablet, with consent and manager-only controls.";

export const Route = createFileRoute("/korner-ask")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://www.thatkorner.com/korner-ask" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
    links: [{ rel: "canonical", href: "https://www.thatkorner.com/korner-ask" }],
  }),
  component: KornerAsk,
});
